import { render } from "./CardRecentOrders.vue?vue&type=template&id=2bfee2bc&lang=html"
import script from "./CardRecentOrders.vue?vue&type=script&lang=js"
export * from "./CardRecentOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__